// TODO: TRANSFER_FEE may differ by currency. Needs backend coordination when multi-currency ships.
export const TRANSFER_FEE = 1.7;

export const BANK_PARTNER_PROMO_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const ALLY_PURPLE = '#6B2D8B';

export const ALLY_CASH_FUND_PROMO_URL = 'https://www.ally.com/bank/checking-and-savings-accounts/?CP=TPM-WithJoy-CFPromoModal-DIGITAL';
